import React from 'react';
import PropTypes from 'prop-types';
import { ContextMenu, MenuItem } from 'react-contextmenu';

const DynamicContextMenu = ({ menuOptions, handleMenuOptions, menuID }) => {
  function renderMenuItems() {
    return menuOptions.map(menuOption => (
      <MenuItem key={menuOption} onClick={() => handleMenuOptions(menuOption)}>
        {menuOption}
      </MenuItem>
    ));
  }

  return <ContextMenu id={menuID}>{renderMenuItems()}</ContextMenu>;
};

DynamicContextMenu.propTypes = {
  menuOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleMenuOptions: PropTypes.func.isRequired,
  menuID: PropTypes.string.isRequired,
};

export default DynamicContextMenu;
